import { z } from "zod/v4";
import { DoctorsIdSchema, PatientsIdSchema } from "../zodSchemas.js";
import { BigNumberCodec } from "./BigNumber.js";
export const QuoteLineSchema = z.object({
    name: z.string(),
    tooth: z.array(z.string()), // Vec<String>
    ccam_code: z.string().nullable(), // Option<String>
    fees: BigNumberCodec,
    base: BigNumberCodec,
    tx: z.number(), // u8
    amo: BigNumberCodec,
    copay: BigNumberCodec,
    materials: z.string(),
    index: z.number(),
});
export const QuoteSchema = z.object({
    id: z.string(), //uuid
    patient_id: PatientsIdSchema,
    creationDate: z.date(),
    deliveryDate: z.date().nullable(),
    expirationDate: z.date(),
    acceptationDate: z.date().nullable(),
    lines: QuoteLineSchema.array(),
    alternative: QuoteLineSchema.array(),
    owner: DoctorsIdSchema,
});
//# sourceMappingURL=DevisSchema.js.map